import React from 'react';
import { connect } from 'react-redux';

import LoSentimos from './lo-sentimos.cmpt';
import Contrato from './contrato.cmpt';
import Confidencialidad from './confidencialidad.cmpt';
import Bienvenido from './bienvenido.cmpt';

const mapState = (state) => {
	return {
		loading: state.global.loading,
		paso: state.contrato.paso
	};
}

const mapDispatch = (dispatch) => {
	return {
		loader: (show) => {
			dispatch({"type": "LOADER", "show": show});
		},
		pasoInicial: () => {
			dispatch({ "type": "CONTRATOS_PASO", paso: 1});
		}
	}
}

class Flujo extends React.Component {
	
	componentWillMount = () => {
		this.props.pasoInicial();
	}
	
	render() {
		return <div className="content-wrap">
			<div className="container">
				<div className="white-box mt-70">
					{ this.props.paso == 0 && 
						<LoSentimos />
					}
					{ this.props.paso == 1 && 
						<Contrato />
					}
					{ this.props.paso == 2 && 
						<Confidencialidad />
					}
					{ this.props.paso == 3 && 
						<Bienvenido />
					}
				</div>
			</div>
		</div>
	}
}

export default connect(mapState, mapDispatch)(Flujo);


// WEBPACK FOOTER //
// ./src/contrato/flujo.cmpt.js